import React, { useCallback, useEffect, useState } from "react";
import { useUser } from "../../context/user-context";
import Dashboard from "../../components/Dashboard";
import { RiCompass3Line } from "react-icons/ri";
import Navbar from "../../components/Navbar";
import { CgAddR } from "react-icons/cg";

import {
  AiOutlineEyeInvisible,
  AiOutlineEye,
  AiFillBulb,
  AiOutlineSwap,
} from "react-icons/ai";
import { deexPay, favChart, moneySend, nairaIcon } from "../../assets/images";
import useAllRates from "../../components/utils/GetAllRates";
import {
  coins,
  DEFAULT_UTILITY_PAYMENT_SOURCE,
} from "../../constants/constants";
import RecentTransaction from "./RecentTransaction";
import TransactionDetailsModal from "../activity/TransactionDetailsModal";
import ActivityDetailsModal from "../activity/ActivityDetailsModal";
import QuickActions from "./QuickActions";
import { FaUsers } from "react-icons/fa";
import SelectCoin from "./deposit/SelectCoin";
import SelectDNetwork from "./deposit/SelectDNetwork";
import DepositAddy from "./deposit/DepositAddy";
import SelectType from "./sellCrypto/SelectType";
import SellFromDeex from "./sellCrypto/SellFromDeex";
import Pending from "./sellCrypto/Pending";
import SellFromExAddy from "./sellCrypto/SellFromExAddy";
import TransferFund from "./sellCrypto/TransferFund";
import SelectCard from "./giftcards/SelectCard";
import SelectCardValue from "./giftcards/SelectCardValue";
import GiftcardPreview from "./giftcards/GiftcardPreview";
import UploadGiftcard from "./giftcards/UploadGiftcard";
import GifcardSent from "./giftcards/GifcardSent";
import Rewards from "./rewards/Rewards";
import useUserAsset from "../../hooks/useUserAssets";
import { formatAmount } from "../../utils/formatTime";
import { BiPhone } from "react-icons/bi";
import { LuLightbulb } from "react-icons/lu";
import { PiTrophyBold } from "react-icons/pi";
import BuyAirtime from "./utilities/airtime/BuyAirtime";
import AirtimePreview from "./utilities/airtime/AirtimePreview";
import BuySuccess from "./utilities/airtime/BuySuccess";
import BuyData from "./utilities/data/BuyData";
import DataPreview from "./utilities/data/DataPreview";
import DataSuccess from "./utilities/data/DataSuccess";
import BuyElectricity from "./utilities/electricity/BuyElectricity";
import ElectricPreview from "./utilities/electricity/ElectricPreview";
import ElectricSuccess from "./utilities/electricity/ElectricSuccess";
import { ElectricityReceipt } from "./utilities/electricity/types";
import Referral from "../settings/Referral";
// import UpdateModal from "../../components/UpdateModal";
import GiftcardRate from "../trade/GiftcardRate";
import RedeemModal from "./rewards/RedeemModal";
import { useLocation, useNavigate } from "react-router-dom";
import {
  hasNotificationLink,
  openNotificationLink,
  type NotificationLink,
} from "../../utils/notificationLink";
import SurveyBanner from "../../components/survey/SurveyBanner";
// import CompleteKyc from "../../components/CompleteKyc";
import { useQuery } from "@tanstack/react-query";
import useAuthAxios from "../../utils/baseAxios";
import { API } from "../../constants/api";
import {
  SHOW_ADD_PHONE_AFTER_LOGIN_KEY,
  PHONE_VERIFY_CHECK_DISMISSED_KEY,
} from "../../constants/sessionStorageKeys";
import toast from "react-hot-toast";
import { errorMessage } from "../../utils/errorMessage";
import { IoCloseCircle, IoChevronForward, IoGiftOutline } from "react-icons/io5";
import { TbMessageExclamation } from "react-icons/tb";
import Betting from "./utilities/betting/Betting";
import BettingPreview from "./utilities/betting/BettingPreview";
import BettingSuccess from "./utilities/betting/BettingSuccess";
import PhoneCheck from "../../components/phoneNumber/PhoneCheck";
import AddPhone from "../../components/phoneNumber/AddPhone";
import Success from "../../components/phoneNumber/Success";
import AddOtp from "../../components/phoneNumber/AddOtp";
import Tranfer from "./transfer/Tranfer";
import TransferPreview from "./transfer/TransferPreview";
import TransferSuccess from "./transfer/TransferSuccess";

import ChangeTxnPin from "../settings/security/ChangeTxnPin";
import SellPreview from "./sellCrypto/SellPreview";
import DeexPending from "./sellCrypto/DeexPending";
import ClaimModal from "./ClaimModal";
import InviteCodeModal from "./InviteCodeModal";
import InviteCodeProgressCard, {
  getInProgressMembership,
  useJoinedInviteCodes,
} from "./InviteCodeProgressCard";
import GenerateStatament from "../settings/generateStatement/GenerateStatament";

import OpenWrappedModal from "./wrapped/OpenWrappedModal";
// import { useAudio } from "../../context/audio-context";
import useKycDetails from "../../hooks/useKycDetails";

const WHATS_NEW_KEY = "whatsNewLastShown";
const WHATS_NEW_INTERVAL = 3 * 24 * 60 * 60 * 1000; // 3 days in ms

const KYC_BANNER_DISMISSED_KEY = "crypto_kyc_banner_dismissed";
// Holds the id of the last pop-up image the user actually dismissed. Was the image url
// under the old key "displayedPopupImage"; the id is stabler, so the key changed with it —
// one extra pop-up for existing users on first load, then it settles.
const POPUP_SEEN_KEY = "displayedPopupImageId";

const isStageComplete = (
  stage: { status?: string; data?: { status?: string } } | null | undefined
): boolean => {
  if (!stage) return false;
  const s = stage.status?.toLowerCase();
  const dataStatus = stage.data?.status?.toLowerCase();
  return s === "success" || s === "approved" || dataStatus === "approved";
};

const isStagePending = (
  stage: { status?: string } | null | undefined
): boolean => {
  if (!stage) return false;
  return stage.status?.toLowerCase() === "pending";
};

const Crypto = () => {
  const { isOpen } = useUser();
  // const { play } = useAudio();

  const navigate = useNavigate();
  const location = useLocation();
  const { userDetails } = useUser();
  const axiosInstance = useAuthAxios();
  const { data: kycDetailsData } = useKycDetails();
  const [kycBannerDismissed, setKycBannerDismissed] = useState(false);
  const [screen, setScreen] = useState<boolean>(true);
  const [visible, setVisible] = useState<boolean>(false);
  const [depositNetworks, setDepositNetworks] = useState<any[]>([]);
  const [depositCoinName, setDepositCoinName] = useState<string>("");
  const [depositNetworkName, setDepositNetworkName] = useState<string>("");
  const [openDeposit, setOpenDeposit] = useState<boolean>(false);
  const [openDepositAddy, setOpenDepositAddy] = useState<boolean>(false);
  const [openDepositNetwork, setOpenDepositNetwork] = useState<boolean>(false);
  const [openSellFrom, setOpenSellFrom] = useState<boolean>(false);
  const [openSellFromDeex, setOpenSellFromDeex] = useState<boolean>(false);
  const [openSellFromExAddy, setOpenSellFromExAddy] = useState<boolean>(false);
  const [openSellPending, setOpenSellPending] = useState<boolean>(false);
  const [openSellTransfer, setOpenSellTransfer] = useState<boolean>(false);
  const [openGiftcardRate, setOpenGiftcardRate] = useState<boolean>(false);
  const [openSellDPreview, setOpenSellDPreview] = useState<boolean>(false);
  const [openSellDPending, setOpenSellDPending] = useState<boolean>(false);
  const [sellDCoinAmount, setSellDCoinAmount] = useState<string>("");
  const [sellDUsdAmount, setSellDUsdAmount] = useState<string>("");
  const [selectedSellDCoinObj, setSelectedSellDCoinObj] = useState<any>(null);

  //for external wallet
  const [selectedCoinObj, setSelectedCoinObj] = useState<any>(null);
  const [selectedNetwork, setSelectedNetwork] = useState<string>("");
  //For Giftcards
  const [openSelectCard, setOpenSelectCard] = useState<boolean>(false);
  const [openSelectCardValue, setOpenSelectCardValue] =
    useState<boolean>(false);
  const [openGiftcardPreview, setOpenGiftcardPreview] =
    useState<boolean>(false);
  const [openGicardUpload, setOpenGicardUpload] = useState<boolean>(false);
  const [openGicardDone, setOpenGicardDone] = useState<boolean>(false);
  const [openRewards, setOpenRewards] = useState<boolean>(false);
  const [cardId, setCardId] = useState<string>("");
  const [cardName, setCardName] = useState<string>("");
  const [cardImg, setCardImg] = useState<string>("");
  const [card, setCard] = useState<any[]>([]);
  const [cardType, setCardType] = useState<string>("physical");
  const [receiptName, setReceiptName] = useState<string>("");
  const [openRefer, setOpenRefer] = useState<boolean>(false);
  const [openInviteCode, setOpenInviteCode] = useState<boolean>(false);

  const [denominationData, setDenominationData] = useState<any[]>([]);

  // console.log(userDetails);
  const [openPin, setOpenPin] = useState<boolean>(false);
  const { totalBalance, totalBalanceNGN, loading } = useUserAsset();

  //utilities
  const [openAirtime, setOpenAirtime] = useState<boolean>(false);
  const [openData, setOpenData] = useState<boolean>(false);
  const [openElectric, setOpenElectric] = useState<boolean>(false);
  const [openBetting, setOpenBetting] = useState<boolean>(false);
  const [openAirtimePreview, setOpenAirtimePreview] = useState<boolean>(false);
  const [openBettingPreview, setOpenBettingPreview] = useState<boolean>(false);
  const [openElectricPreview, setOpenElectricPreview] =
    useState<boolean>(false);
  const [openDataPreview, setOpenDataPreview] = useState<boolean>(false);
  const [openAirtimeSuccess, setOpenAirtimeSuccess] = useState<boolean>(false);
  const [openDataSuccess, setOpenDataSuccess] = useState<boolean>(false);
  const [openBettingSuccess, setOpenBettingSuccess] = useState<boolean>(false);
  const [openElectricSuccess, setOpenElectricSuccess] =
    useState<boolean>(false);
  const [amount, setAmount] = useState<string>("");
  const [electricAmount, setElectricAmount] = useState<string>("");
  const [dataAmount, setDataAmount] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [electricPhone, setElectricPhone] = useState<string>("");
  const [dataPhone, setDataPhone] = useState<string>("");
  const [dataNetwork, setDataNetwork] = useState<string>("");
  const [dataNetworkName, setDataNetworkName] = useState<string>("");
  const [dataProductSlug, setDataProductSlug] = useState<string>("");
  const [dataPaymentSource, setDataPaymentSource] = useState<"NGN" | "USDT">(
    DEFAULT_UTILITY_PAYMENT_SOURCE
  );
  const [network, setNetwork] = useState<string>("");
  const [networkName, setNetworkName] = useState<string>("");
  const [airtimePaymentSource, setAirtimePaymentSource] = useState<
    "NGN" | "USDT"
  >(DEFAULT_UTILITY_PAYMENT_SOURCE);
  const [planName, setPlanName] = useState<string>("");
  const [meterNo, setMeterNo] = useState<string>("");
  const [electricProviderName, setElectricProviderName] = useState<string>("");
  const [electricProductSlug, setElectricProductSlug] = useState<string>("");
  const [electricPaymentSource, setElectricPaymentSource] = useState<
    "NGN" | "USDT"
  >(DEFAULT_UTILITY_PAYMENT_SOURCE);
  const [electricCustomerName, setElectricCustomerName] = useState<string>("");
  const [electricReceipt, setElectricReceipt] =
    useState<ElectricityReceipt | null>(null);
  // const [showUpdatdeModal, setShowUpdateModal] = useState(false);
  const [redeemModal, setRedeemModal] = useState<boolean>(false);
  const [isNotVerified, setIsNotVerified] = useState<boolean>(false);
  const [toggleKyc, setToggleKyc] = useState<boolean>(false);
  const [openAddPhone, setOpenAddPhone] = useState(false);
  const [openAddOtp, setOpenAddOtp] = useState(false);
  const [openPhoneSuccess, setOpenPhoneSuccess] = useState(false);
  // Transfer modal state
  const [openTransfer, setOpenTransfer] = useState(false);
  const [openTransferPreview, setOpenTransferPreview] = useState(false);
  const [openTransferSuccess, setOpenTransferSuccess] = useState(false);

  // Transfer data state (distinct names)
  const [transferAmount, setTransferAmount] = useState("");
  const [transferBankName, setTransferBankName] = useState("");
  const [transferBankNumber, setTransferBankNumber] = useState("");
  const [transferBankCode, setTransferBankCode] = useState("");
  const [transferUserBankName, setTransferUserBankName] = useState("");
  const [transferSelectedCoinObj, setTransferSelectedCoinObj] = useState(null);
  const [transferFee, setTransferFee] = useState(50); // or your logic

  // console.log(userDetails?.user?.migratedToHostCapital);
  const [isPopUpModalOpen, setIsPopUpModalOpen] = useState<boolean>(false);

  //betting
  const [betId, setBetId] = useState<string>("");
  const [customerId, setCustomerId] = useState<string>("");
  const [betAmount, setBetAmount] = useState<string>("");
  const [providerName, setProviderName] = useState<string>("");
  const [customerName, setCustomerName] = useState<string>("");
  const [bettingPaymentSource, setBettingPaymentSource] = useState<
    "NGN" | "USDT"
  >(DEFAULT_UTILITY_PAYMENT_SOURCE);

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // const [showWhatsNew, setShowWhatsNew] = useState<boolean>(false);
  // const [streakDetails, setStreakDetails] = useState<any[]>([]);

  const [selectedTransaction, setSelectedTransaction] = useState<any>(null);
  const [showReceipt, setShowReceipt] = useState<boolean>(false);
  const [showClaimModal, setShowClaimModal] = useState<boolean>(false);
  const [openWrapped, setOpenWrapped] = useState<boolean>(false);
  const [openOpenWrappedModal, setOpenOpenWrappedModal] =
    useState<boolean>(false);
  const [openStatement, setOpenStatement] = useState<boolean>(false);
  const [openStatementSuccess, setOpenStatementSuccess] =
    useState<boolean>(false);
  // useEffect(() => {
  //   if (userDetails?.user?.migratedToHostCapital === false) {
  //     setShowUpdateModal(true);
  //   } else {
  //     setShowUpdateModal(false);
  //   }
  // }, [userDetails?.user?.migratedToHostCapital]);
  const details = kycDetailsData?.kycDetails;
  const level1Complete = isStageComplete(details?.first_stage);
  const level2Complete = isStageComplete(details?.second_stage);
  const level3Complete = isStageComplete(details?.third_stage);
  const currentLevel = level3Complete
    ? 3
    : level2Complete
    ? 2
    : level1Complete
    ? 1
    : 0;
  const hasPending =
    isStagePending(details?.first_stage) ||
    isStagePending(details?.second_stage) ||
    isStagePending(details?.third_stage);
  const pendingLevel = details
    ? isStagePending(details.first_stage)
      ? 1
      : isStagePending(details.second_stage)
      ? 2
      : isStagePending(details.third_stage)
      ? 3
      : undefined
    : undefined;

  // isNotVerified: true when KYC level 1 (first_stage) is not started or pending
  useEffect(() => {
    setIsNotVerified(!level1Complete);
    setToggleKyc(!level1Complete);
  }, [level1Complete]);

  const showKycBanner = (currentLevel < 3 || hasPending) && !kycBannerDismissed;

  useEffect(() => {
    try {
      if (sessionStorage.getItem(KYC_BANNER_DISMISSED_KEY)) {
        setKycBannerDismissed(true);
      }
    } catch {
      // ignore
    }
  }, []);

  const handleDismissKycBanner = () => {
    try {
      sessionStorage.setItem(KYC_BANNER_DISMISSED_KEY, "true");
      setKycBannerDismissed(true);
    } catch {
      setKycBannerDismissed(true);
    }
  };

  const handleOpenKycOnboarding = () => {
    navigate("/kyc-verification");
  };

  // console.log(userDetails);

  // Show DeeX Wrapped intro modal once per user (per browser) until first view
  // useEffect(() => {
  //   try {
  //     const hasViewed = window.localStorage.getItem(WRAPPED_LOCAL_STORAGE_KEY);
  //     if (!hasViewed) {
  //       setOpenOpenWrappedModal(true);
  //     }
  //   } catch {
  //     // If storage unavailable, fall back to showing modal once per session
  //     setOpenOpenWrappedModal(true);
  //   }
  // }, []);

  //Get pop-up image
  const getPopUp = async () => {
    const response = await axiosInstance.get(
      API.getAdvNotiff("active", "popup")
    );
    return response.data;
  };
  const { data: notiff, error: error1 } = useQuery({
    queryKey: ["get-pop-up", !isNotVerified],
    queryFn: getPopUp,
    retry: 1,
    enabled: !isNotVerified,
  });
  useEffect(() => {
    if (error1) {
      const newError = error1 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error1]);
  const popupNotification = notiff?.data?.notifications?.[0];
  const popupImage = popupNotification?.images?.[0]?.url;
  // Keyed off the image id, not its url: re-uploading the same file changes nothing, while
  // editing an image's url would otherwise re-show a pop-up the user has already seen.
  const popupImageId = popupNotification?.images?.[0]?._id;
  const popupLink: NotificationLink = popupNotification?.link ?? null;

  useEffect(() => {
    if (!popupImageId) return;
    const seen = localStorage.getItem(POPUP_SEEN_KEY);
    if (seen !== popupImageId) setIsPopUpModalOpen(true);
  }, [popupImageId]);

  // The seen-key is written here rather than when the modal renders: writing on render
  // counted a pop-up as seen even if the user never actually saw it (tab backgrounded, an
  // immediate navigation). Mobile records it on dismiss or CTA tap; match that.
  const handleCloseModal = () => {
    if (popupImageId) {
      try {
        localStorage.setItem(POPUP_SEEN_KEY, popupImageId);
      } catch {
        // Blocked storage just means the pop-up shows again; not worth surfacing.
      }
    }
    setIsPopUpModalOpen(false);
  };

  // Tapping the CTA both dismisses and navigates — navigating without dismissing leaves
  // the modal sitting over the destination and traps the user behind it.
  const handlePopUpCta = () => {
    handleCloseModal();
    openNotificationLink(popupLink, navigate);
  };

  // console.log(popupImage);

  //Get sliders
  const getSliders = async () => {
    const response = await axiosInstance.get(
      API.getAdvNotiff("active", "sliders")
    );
    return response.data;
  };
  const { data: sliders, error: error2 } = useQuery({
    queryKey: ["get-sliders", !isNotVerified],
    queryFn: getSliders,
    retry: 1,
    enabled: !isNotVerified,
  });
  useEffect(() => {
    if (error2) {
      const newError = error2 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error2]);
  // One slide per notification, using images[0]. Flattening every image of every
  // notification into a single url list loses the link association — the CTA lives on the
  // notification, not on the image.
  const slides: {
    id: string;
    url: string;
    link: NotificationLink;
  }[] = React.useMemo(
    () =>
      (sliders?.data?.notifications ?? [])
        .map((item: any) => ({
          id: item?.images?.[0]?._id ?? item?._id,
          url: item?.images?.[0]?.url,
          link: (item?.link ?? null) as NotificationLink,
        }))
        .filter((slide: { url?: string }) => Boolean(slide.url)),
    [sliders]
  );

  useEffect(() => {
    if (slides.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 10000);

    return () => clearInterval(interval);
  }, [slides.length]);

  useEffect(() => {
    setCurrentImageIndex(0);
  }, [slides.length]);
  // console.log(sliders?.data?.notifications);

  //Get emergency
  const getEmergency = async () => {
    const response = await axiosInstance.get(
      API.getAdvNotiff("active", "emergency")
    );
    return response.data;
  };
  const { data: emergency, error: error3 } = useQuery({
    queryKey: ["get-emergency", !isNotVerified],
    queryFn: getEmergency,
    retry: 1,
    enabled: !isNotVerified,
  });
  useEffect(() => {
    if (error3) {
      const newError = error3 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error3]);
  const activeEmergency = emergency?.data?.notifications?.[0];
  const emergencyTopic = activeEmergency?.topic;
  const emergencyMessage = activeEmergency?.message;
  const formatEmergencyTopic = (topic?: string) => {
    if (!topic) return "Emergency Alert";
    return topic
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  // console.log(streakDetails);

  const getSignupStats = async () => {
    const response = await axiosInstance.get(API.getSignupStats);
    return response.data;
  };
  const { data: signupStats, error: error5 } = useQuery({
    queryKey: ["get-signup-stats", !isNotVerified],
    queryFn: getSignupStats,
    retry: 1,
    enabled: !isNotVerified,
  });
  useEffect(() => {
    if (error5) {
      const newError = error5 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error5]);

  const { eligible, canClaim } = signupStats?.data?.status || {};

  const { data: joinedInviteData, isLoading: isJoinedInviteLoading } =
    useJoinedInviteCodes(!isNotVerified);
  const inProgressMembership = getInProgressMembership(
    joinedInviteData?.data?.memberships
  );

  useEffect(() => {
    const st = location.state as {
      openSellFromClaim?: boolean;
      openRewardsFromClaim?: boolean;
    } | null;
    if (!st) return;
    let clear = false;
    if (st.openSellFromClaim) {
      setOpenSellFrom(true);
      clear = true;
    }
    if (st.openRewardsFromClaim) {
      setOpenRewards(true);
      clear = true;
    }
    if (clear) {
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, location.pathname, navigate]);

  // const getWrappedData = async () => {
  //   const response = await axiosInstance.get(API.getWrappedDeet);
  //   return response.data;
  // };

  // const { data: wrappedDeets, error: error6 } = useQuery({
  //   queryKey: ["wrapped-details"],
  //   queryFn: getWrappedData,
  //   retry: 1,
  // });

  // useEffect(() => {
  //   if (error6) {
  //     const newError = error6 as any;
  //     toast.error(errorMessage(newError?.message || newError?.data?.message));
  //   }
  // }, [error6]);

  // const handleViewWrapped = async () => {
  //   try {
  //     localStorage.setItem(WRAPPED_LOCAL_STORAGE_KEY, "true");
  //   } catch {}

  //   await play(); // ✅ user gesture safe

  //   setOpenWrapped(true);
  //   setOpenOpenWrappedModal(false);
  // };

  // console.log(wrappedDeets);
  useEffect(() => {
    // If canClaim is true, stop showing the modal (provided eligible is true)
    if (canClaim) {
      setShowClaimModal(false);
      return;
    }

    // Only show if eligible is true and canClaim is false (keep showing until canClaim becomes true)
    if (!eligible) {
      return;
    }

    const today = new Date().toDateString();
    const lastShown = localStorage.getItem("claimModalLastShown");

    if (lastShown !== today) {
      const noOtherModalsOpen = !(
        openRewards ||
        openDeposit ||
        openSelectCard ||
        openSelectCardValue ||
        openGiftcardPreview ||
        openGicardUpload ||
        openGicardDone ||
        openAirtime ||
        openAirtimePreview ||
        openAirtimeSuccess ||
        openBetting ||
        openBettingPreview ||
        openBettingSuccess ||
        openData ||
        openDataPreview ||
        openDataSuccess ||
        openElectric ||
        openElectricPreview ||
        openElectricSuccess ||
        openRefer ||
        redeemModal ||
        toggleKyc ||
        openSellFrom ||
        openSellPending ||
        openSellTransfer ||
        openSellFromExAddy ||
        openSellFromDeex ||
        isPopUpModalOpen ||
        openTransfer ||
        openTransferPreview ||
        openTransferSuccess ||
        openWrapped ||
        openOpenWrappedModal
      );

      if (noOtherModalsOpen) {
        setShowClaimModal(true);
        localStorage.setItem("claimModalLastShown", today);
      }
    }
  }, [
    eligible,
    canClaim,
    openRewards,
    openDeposit,
    openSelectCard,
    openSelectCardValue,
    openGiftcardPreview,
    openGicardUpload,
    openGicardDone,
    openAirtime,
    openAirtimePreview,
    openAirtimeSuccess,
    openBetting,
    openBettingPreview,
    openBettingSuccess,
    openData,
    openDataPreview,
    openDataSuccess,
    openElectric,
    openElectricPreview,
    openElectricSuccess,
    openRefer,
    redeemModal,
    toggleKyc,
    openSellFrom,
    openSellPending,
    openSellTransfer,
    openSellFromExAddy,
    openSellFromDeex,
    isPopUpModalOpen,
    openTransfer,
    openTransferPreview,
    openTransferSuccess,
    openWrapped,
    openOpenWrappedModal,
  ]);

  const [openPhoneCheck, setOpenPhoneCheck] = useState<boolean>(false);
  //check if o modal is open
  const isModalOpen =
    openRewards ||
    openDeposit ||
    openSelectCard ||
    openSelectCardValue ||
    openGiftcardPreview ||
    openGicardUpload ||
    openGicardDone ||
    openAirtime ||
    openAirtimePreview ||
    openAirtimeSuccess ||
    openBetting ||
    openBettingPreview ||
    openBettingSuccess ||
    openData ||
    openDataPreview ||
    openDataSuccess ||
    openElectric ||
    openElectricPreview ||
    openElectricSuccess ||
    openSellFrom ||
    openSellPending ||
    openSellTransfer ||
    openSellFromExAddy ||
    openSellFromDeex ||
    isPopUpModalOpen ||
    openTransfer ||
    openTransferPreview ||
    openTransferSuccess ||
    showClaimModal ||
    openWrapped ||
    openOpenWrappedModal ||
    openAddPhone ||
    openPin ||
    openAddOtp ||
    openPhoneCheck ||
    openPhoneSuccess;

  const phoneNumber = userDetails?.user?.phone?.number;
  const pinAvailable = userDetails?.user?.isPinSelected;

  useEffect(() => {
    if (!userDetails?.user || isModalOpen || hasPending || toggleKyc) return;

    if (!pinAvailable) {
      setOpenPin(true); // show PIN modal
    } else {
      setOpenPin(false); // PIN already set
    }
  }, [isModalOpen, pinAvailable, toggleKyc, userDetails, hasPending]);

  const onDismissPhoneVerifyPrompt = useCallback(() => {
    try {
      localStorage.setItem(PHONE_VERIFY_CHECK_DISMISSED_KEY, "true");
    } catch {
      // ignore
    }
  }, []);

  useEffect(() => {
    if (
      !userDetails?.user ||
      isModalOpen ||
      hasPending ||
      toggleKyc ||
      openPin || // ✅ Still waiting for PIN modal
      !pinAvailable // ✅ Don't proceed until PIN is set
    )
      return;

    const phoneNumber = userDetails.user.phone?.number;
    const isPhoneVerified = userDetails.user.phone?.isVerified;

    if (!phoneNumber && !isPhoneVerified) {
      const showAddPhoneAfterLogin =
        sessionStorage.getItem(SHOW_ADD_PHONE_AFTER_LOGIN_KEY) === "true";
      if (showAddPhoneAfterLogin) {
        setOpenAddPhone(true);
      }
      setOpenPhoneCheck(false);
    } else if (phoneNumber && !isPhoneVerified) {
      let dismissed = false;
      try {
        dismissed =
          localStorage.getItem(PHONE_VERIFY_CHECK_DISMISSED_KEY) === "true";
      } catch {
        dismissed = false;
      }
      if (!dismissed) {
        setOpenPhoneCheck(true);
      } else {
        setOpenPhoneCheck(false);
      }
      setOpenAddPhone(false);
    } else {
      try {
        localStorage.removeItem(PHONE_VERIFY_CHECK_DISMISSED_KEY);
      } catch {
        // ignore
      }
      setOpenPhoneCheck(false);
      setOpenAddPhone(false);
    }
  }, [isModalOpen, toggleKyc, userDetails, openPin, pinAvailable, hasPending]);

  useEffect(() => {
    if (isModalOpen || openPin || openAddPhone) return;

    const lastShown = localStorage.getItem(WHATS_NEW_KEY);
    const now = Date.now();

    if (!lastShown || now - Number(lastShown) > WHATS_NEW_INTERVAL) {
      // setShowWhatsNew(true);
      localStorage.setItem(WHATS_NEW_KEY, now.toString());
    }
  }, [isModalOpen, openPin, openAddPhone]);

  // const getSignupStats = async () => {
  //   const response = await axiosInstance.get(API.getSignupStats);
  //   return response.data;
  // };
  // const {
  //   data: signupStats,
  //   error: error5,
  //   isPending: loading5,
  // } = useQuery({
  //   queryKey: ["get-signup-stats"],
  //   queryFn: getSignupStats,
  //   retry: 1,
  // });
  // useEffect(() => {
  //   if (error5) {
  //     const newError = error5 as any;
  //     toast.error(errorMessage(newError?.message || newError?.data?.message));
  //   }
  // }, [error5]);

  const rates = useAllRates();
  return (
    <div className="lgss:flex font-manrope  lgss:flex-row h-screen lgss:h-screen bg-[#E7EBEE]   dark:bg-[#13181B]">
      <Dashboard />
      <div
        className={
          isOpen
            ? "w-full h-full pt-0  font-manrope overflow-hidden lgss:px-0 flex flex-col justify-start item-start lgss:w-[80%]"
            : "w-full h-full pt-0  font-manrope overflow-auto pb-20 lgss:px-0 flex flex-col justify-start item-start lgss:w-[80%]"
        }
      >
        <Navbar />
        <div className="w-full lgss:mt-10">
          {openRewards ? (
            <Rewards
              setOpenRewards={setOpenRewards}
              setRedeemModal={setRedeemModal}
            />
          ) : (
            <div className="w-full lgss:px-8 xl:px-12 xxl:px-12 xxxl:px-16 md:px-12 mds:px-8 px-4 flex flex-col lgss:flex-row gap-6">
              <div className="w-full lgss:w-1/2  mt-6 lgss:mt-0   bg-white dark:bg-[#1C2227] rounded-xl">
                {emergencyMessage && (
                  <div
                    role="alert"
                    aria-live="assertive"
                    className="w-full rounded-t-xl border-b border-red-400/20 bg-gradient-to-br from-[#7A1515] via-[#911D1D] to-[#6B1212] px-4 py-3.5 shadow-[inset_0_1px_0_rgba(255,255,255,0.08)]"
                  >
                    <div className="flex items-start gap-3">
                      <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white/10 ring-2 ring-white/15 animate-pulse">
                        <TbMessageExclamation className="text-[20px] text-white" />
                      </div>
                      <div className="min-w-0 flex-1">
                        <div className="flex flex-wrap items-center gap-2">
                          <span className="inline-flex items-center rounded-md bg-white/15 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-red-50">
                            Emergency
                          </span>
                        </div>
                        <h4 className="mt-2 text-[13px] sm:text-[14px] font-bold leading-snug text-white">
                          {formatEmergencyTopic(emergencyTopic)}
                        </h4>
                        <p className="mt-1 text-[12px] sm:text-[13px] font-medium leading-relaxed text-red-50/95">
                          {emergencyMessage}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                <div
                  className={`w-full pb-6 lgss:pb-6 pt-6  bg-white dark:bg-[#1C2227] ${
                    showKycBanner ? "rounded-xl" : "rounded-t-xl"
                  }`}
                >
                  <div className=" w-full lgss:w-[65%]  px-4  flex justify-start items-center     text-white  ">
                    <button
                      onClick={() => setScreen(true)}
                      className={
                        screen
                          ? "w-1/2  text-white bg-secondary_button text-[12px] py-2 rounded-[6px] font-bold"
                          : "w-1/2   text-gray-500   text-[12px] font-bold"
                      }
                    >
                      Crypto
                    </button>
                    <button
                      onClick={() => setScreen(false)}
                      className={
                        !screen
                          ? "w-1/2  text-white bg-secondary_button text-[12px] py-2 rounded-[6px] font-bold"
                          : "w-1/2   text-gray-500   text-[12px] font-bold"
                      }
                    >
                      Gift cards
                    </button>
                  </div>

                  <div className="px-6 mt-8">
                    <h4 className="text-[13px]  text-gray-600 text-center dark:text-gray-400 uppercase">
                      {userDetails?.user?.profile?.firstName}'s TOTAL BALANCE
                    </h4>
                    <div className="flex justify-center mt-2 gap-3 items-center">
                      <h4
                        className={`font-sora ${"text-gray-800 dark:text-gray-100"}  font-bold text-[32px]`}
                      >
                        {visible
                          ? `$${
                              loading ? "----" : formatAmount(totalBalance ?? 0)
                            }`
                          : "*****"}
                      </h4>
                      {visible ? (
                        <AiOutlineEyeInvisible
                          onClick={() => setVisible((prev) => !prev)}
                          className={`${"text-[#869AA9] dark:text-gray-200"}   text-[20px]`}
                        />
                      ) : (
                        <AiOutlineEye
                          onClick={() => setVisible((prev) => !prev)}
                          className={`${"text-[#869AA9] dark:text-gray-200"} -mt-4 text-[20px]`}
                        />
                      )}
                    </div>
                    <h4 className="text-[13px] text-center text-[#BE6B0A]  font-medium ">
                      {visible
                        ? `₦ ${
                            loading
                              ? "----"
                              : formatAmount(totalBalanceNGN ?? 0)
                          }`
                        : "*****"}
                    </h4>
                    {screen ? (
                      <div className="w-full flex justify-center items-center mt-6 gap-4">
                        <button
                          onClick={() => {
                            if (isNotVerified) {
                              handleOpenKycOnboarding();
                            } else {
                              setOpenDeposit(true);
                            }
                          }}
                          className="flex w-1/2  py-3 rounded-[8px] gap-2   justify-center items-center font-semibold bg-[#D4EBFD] text-secondary_button"
                        >
                          <CgAddR className="text-[16px]" />
                          <h4 className="text-[11px] font-semibold">Deposit</h4>
                        </button>
                        <button
                          onClick={() => {
                            if (isNotVerified) {
                              handleOpenKycOnboarding();
                            } else {
                              setOpenTransfer(true);
                            }
                          }}
                          className="flex w-1/2  py-3 rounded-[8px] gap-2   justify-center items-center font-semibold bg-[#D4EBFD] text-secondary_button"
                        >
                          <img
                            src={deexPay}
                            alt=""
                            className="w-[16px] h-[16px]"
                          />
                          <h4 className="text-[11px] font-semibold">
                            Deex Pay
                          </h4>
                        </button>
                        <button
                          onClick={() => {
                            if (isNotVerified) {
                              handleOpenKycOnboarding();
                            } else {
                              setOpenSellFrom(true);
                            }
                          }}
                          className="flex w-1/2  py-3 rounded-[8px] gap-2   justify-center items-center font-semibold bg-[#095B97] text-[#E8F3FC]"
                        >
                          <AiOutlineSwap className="text-[16px]" />

                          <h4 className="text-[11px] font-semibold">
                            Sell Crypto
                          </h4>
                        </button>
                      </div>
                    ) : (
                      <div className="w-full flex justify-center items-center mt-6 gap-4">
                        <button
                          onClick={() => {
                            if (isNotVerified) {
                              handleOpenKycOnboarding();
                            } else {
                              setOpenGiftcardRate(true);
                            }
                          }}
                          className="flex w-1/2 gap-2 py-3 rounded-[8px]   justify-center items-center font-semibold bg-[#D4EBFD] text-secondary_button"
                        >
                          <div className="w-[16px] h-[16px]">
                            <img
                              src={favChart}
                              className="w-full h-full bg-cover"
                              alt=""
                            />
                          </div>
                          <h4 className="text-[11px] font-semibold">
                            See Rates
                          </h4>
                        </button>
                        <button
                          onClick={() => {
                            if (isNotVerified) {
                              handleOpenKycOnboarding();
                            } else {
                              setOpenSelectCard(true);
                            }
                          }}
                          className="flex w-1/2 gap-2 py-3 rounded-[8px]   justify-center items-center font-semibold bg-[#095B97] text-[#E8F3FC]"
                        >
                          <div className="w-[16px] h-[16px]">
                            <img
                              src={moneySend}
                              className="w-full h-full bg-cover"
                              alt=""
                            />
                          </div>
                          <h4 className="text-[11px] font-semibold">
                            Sell Giftcards
                          </h4>
                        </button>
                      </div>
                    )}
                    {screen && (
                      <div className="w-full mt-6 flex items-center gap-2">
                        <h4 className="text-[13px] text-gray-500 whitespace-nowrap">
                          Today's rate:
                        </h4>
                        {!rates ||
                        !Array.isArray(rates) ||
                        rates.length === 0 ? (
                          <h4 className="text-[12px] text-gray-500">
                            Rates are not available
                          </h4>
                        ) : (
                          <div className="scrolling-container flex-1 overflow-hidden">
                            <div className="flex scrolling-content items-center gap-4">
                              {/* Render content twice for seamless infinite scroll */}
                              {[...Array(2)].map((_, duplicateIndex) =>
                                coins.map((coin, coinIndex) => {
                                  const rateData = (rates as any[]).find(
                                    (rate: any) => rate.abbr === coin.abbr
                                  );
                                  if (!rateData) return null;
                                  return (
                                    <div
                                      key={`${duplicateIndex}-${coin.id}-${coinIndex}`}
                                      className="flex items-center gap-2 whitespace-nowrap"
                                    >
                                      <div className="w-[20px] h-[20px] rounded-full">
                                        <img
                                          src={coin.logo}
                                          className="w-full h-full object-cover"
                                          alt={coin.name}
                                        />
                                      </div>
                                      <div className="text-[12px] text-[#AEBCC6] font-medium">
                                        {coin.abbr}:{" "}
                                        <span className="text-secondary_button text-[12px] font-bold">
                                          ₦
                                          {Number(
                                            rateData.rate
                                          ).toLocaleString()}{" "}
                                          /$
                                        </span>
                                      </div>
                                    </div>
                                  );
                                })
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {showKycBanner && (
                  <div
                    onClick={handleOpenKycOnboarding}
                    className={
                      "mx-auto mt-6 w-[calc(100%-2rem)] max-w-5xl rounded-xl bg-[#042741] dark:bg-[#111827] p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 cursor-pointer"
                    }
                  >
                    <div className="flex items-start gap-3 flex-1 min-w-0">
                      <div className="shrink-0">
                        <AiFillBulb className="text-[#F28A0F] text-[28px] sm:text-[34px]" />
                      </div>
                      <div className="min-w-0">
                        <h4 className="text-gray-200 font-bold text-[14px] sm:text-[16px] leading-snug">
                          {hasPending
                            ? `Your Level ${
                                pendingLevel ?? 1
                              } verification is pending`
                            : currentLevel === 0
                            ? "Verify your account"
                            : `Upgrade to Level ${currentLevel + 1}`}
                        </h4>
                        <h4 className="text-gray-400 mt-1 text-[12px] sm:text-[13px] leading-snug">
                          {hasPending
                            ? "You will be notified when your KYC has been approved."
                            : currentLevel === 0
                            ? "Unlock higher limits by completing KYC."
                            : "Unlock higher trading and withdrawal limits."}
                        </h4>
                      </div>
                    </div>
                    <div className="flex items-center justify-end shrink-0">
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDismissKycBanner();
                        }}
                        className="p-2 rounded-full hover:bg-white/10 transition-colors"
                        aria-label="Dismiss banner"
                      >
                        <IoCloseCircle className="text-gray-300 text-[26px]" />
                      </button>
                    </div>
                  </div>
                )}
                <div
                  className={`w-full px-4   ${
                    showKycBanner ? " rounded-t-xl mt-4" : "mt-4 "
                  }`}
                >
                  <h3 className="font-bold text-paragraph text-[13px]  dark:text-white">
                    Bill Payment
                  </h3>
                  {/* <div className="px-4 py-2 bg-gray-100 dark:bg-[#1F2C36] flex justify-start rounded-t-xl items-center gap-6 w-full ">
                    <h4 className="text-[11px] xs:text-[13px] font-bold bg-gradient-to-r from-[#16BFFD] to-[#CB3066] inline-block text-transparent bg-clip-text">
                      Pay for Bills with Crypto - Get ₦100 cashback
                    </h4>
                  </div> */}
                  <div className="py-4 gap-2  grid grid-cols-4 w-full bg-white dark:bg-[#1C2227] rounded-xl">
                    <button
                      onClick={() => {
                        if (isNotVerified) {
                          handleOpenKycOnboarding();
                        } else {
                          setOpenAirtime(true);
                        }
                      }}
                      className="flex flex-col  border rounded-xl py-2 border-gray-100 shadow-sm dark:border-gray-700 justify-center items-center"
                    >
                      <BiPhone className="text-secondary_button text-[24px]" />
                      <h4 className="text-[#797979] dark:text-gray-400 font-semibold text-[12px] mt-1">
                        Airtime
                      </h4>
                    </button>
                    <button
                      onClick={() => {
                        if (isNotVerified) {
                          handleOpenKycOnboarding();
                        } else {
                          setOpenData(true);
                        }
                      }}
                      className="flex flex-col  border rounded-xl py-2 border-gray-100 shadow-sm dark:border-gray-700 justify-center items-center"
                    >
                      <RiCompass3Line className="text-secondary_button text-[24px]" />
                      <h4 className="text-[#797979] dark:text-gray-400 font-semibold text-[12px] mt-1">
                        Data
                      </h4>
                    </button>
                    <button
                      onClick={() => {
                        if (isNotVerified) {
                          handleOpenKycOnboarding();
                        } else {
                          setOpenElectric(true);
                        }
                      }}
                      className="flex flex-col  border rounded-xl py-2 border-gray-100 shadow-sm dark:border-gray-700 justify-center items-center"
                    >
                      <LuLightbulb className="text-secondary_button text-[24px]" />
                      <h4 className="text-[#797979] dark:text-gray-400 font-semibold text-[12px] mt-1">
                        Electricity
                      </h4>
                    </button>
                    <button
                      onClick={() => {
                        if (isNotVerified) {
                          handleOpenKycOnboarding();
                        } else {
                          setOpenBetting(true);
                        }
                      }}
                      className="flex flex-col  border rounded-xl py-2 border-gray-100 shadow-sm dark:border-gray-700 justify-center items-center"
                    >
                      <PiTrophyBold className="text-secondary_button text-[24px]" />

                      <h4 className="text-[#797979] dark:text-gray-400 font-semibold text-[12px] mt-1">
                        Betting
                      </h4>
                    </button>
                  </div>
                  {/* <div
                    onClick={handleViewWrapped}
                    className="w-full cursor-pointer font-sora text-white px-5 py-3  bg-[#042741] dark:bg-[#111827] rounded-[8px] flex justify-between items-center"
                  >
                    <div className="">
                      <h4 className="text-[16px] font-semibold">2025 Recap</h4>
                      <h4 className="text-[12px] font-medium mt-1 tracking-wide text-gray-100 font-manrope">
                        🔥 See your DeeX Wrapped 2025!
                      </h4>
                    </div>
                    <button>
                      <FaArrowRightLong className="text-[20px]" />
                    </button>
                  </div> */}
                </div>
                <div className="w-full mt-6">
                  {!isJoinedInviteLoading && (
                    <div className="px-4 mb-4">
                      {inProgressMembership ? (
                        <InviteCodeProgressCard
                          membership={inProgressMembership}
                        />
                      ) : (
                        <button
                          type="button"
                          onClick={() => setOpenInviteCode(true)}
                          className="w-full flex items-center gap-3 sm:gap-4 rounded-2xl border border-[#B8DCF5] bg-[#EAF5FD] px-4 py-4 text-left transition-colors hover:border-secondary_button/30 hover:bg-[#DFF0FC] dark:border-[#1E3A5F]/50 dark:bg-[#0B121D] dark:hover:border-secondary_button/40 dark:hover:bg-[#0F1724]"
                        >
                          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#D4EBFD] dark:bg-[#162033]">
                            <IoGiftOutline className="text-[22px] text-secondary_button" />
                          </div>
                          <div className="min-w-0 flex-1">
                            <h4 className="text-[14px] font-bold text-[#13181B] dark:text-white">
                              Have an invite code?
                            </h4>
                            <p className="mt-1 text-[12px] leading-snug text-[#4E606E] dark:text-[#94A3B8]">
                              Enter it to earn rewards on your first deposit and
                              trade
                            </p>
                          </div>
                          <IoChevronForward className="shrink-0 text-[20px] text-secondary_button" />
                        </button>
                      )}
                    </div>
                  )}
                  {/* Narrow widths only. The two columns stack on mobile, so the
                      right-hand instance below would land under the transaction list;
                      here it sits above it, matching the mobile app's dashboard order
                      (invite code -> survey banner -> transactions). */}
                  <SurveyBanner className="mx-4 mb-4 lgss:hidden" />
                  <RecentTransaction
                    setSelectedTransaction={setSelectedTransaction}
                    giftcardOnly={!screen}
                  />
                </div>

                <div className=" bg-[#111827] rounded-[8px] w-[95%] mx-auto px-4 py-2 mb-4 flex justify-between items-center">
                  <div className="flex justify-start items-center gap-2">
                    <img src={nairaIcon} alt="" />
                    <div>
                      <h4 className="text-gray-50 font-semibold text-[10px] ">
                        ₦50,000 coupon bundle this week!
                      </h4>
                      <h4 className="text-gray-400 font-semibold text-[9px] ">
                        Place a trade order to get your bundle
                      </h4>
                    </div>
                  </div>
                  <button
                    onClick={() => setOpenRewards(true)}
                    className="bg-[#4B4EFC] text-white font-bold text-[11px] px-2 py-1 rounded-full"
                  >
                    Claim
                  </button>
                </div>
              </div>
              <div className="w-full lgss:w-1/2 pb-20 lgss:pb-0  ">
                <QuickActions
                  setOpenRewards={setOpenRewards}
                  setOpenDeposit={setOpenDeposit}
                  setOpenStatement={setOpenStatement}
                />
                {slides.length >= 1 &&
                  !isPopUpModalOpen &&
                  !openRewards &&
                  !openDeposit &&
                  !openSelectCard &&
                  !openSelectCardValue &&
                  !openGiftcardPreview &&
                  !openGicardUpload &&
                  !openGicardDone &&
                  !openAirtime &&
                  !openAirtimePreview &&
                  !openAirtimeSuccess &&
                  !openBetting &&
                  !openBettingPreview &&
                  !openBettingSuccess &&
                  !openData &&
                  !openDataPreview &&
                  !openDataSuccess &&
                  !openElectric &&
                  !openElectricPreview &&
                  !openElectricSuccess &&
                  !openRefer &&
                  // !showUpdatdeModal &&
                  !redeemModal &&
                  !toggleKyc &&
                  !openSellFrom &&
                  !openSellPending &&
                  !openSellTransfer &&
                  !openSellFromExAddy &&
                  !openSellFromDeex &&
                  !showClaimModal &&
                  !openPhoneCheck &&
                  !openAddPhone &&
                  !openAddOtp &&
                  !openPhoneSuccess &&
                  !openTransfer &&
                  !openTransferPreview &&
                  !openTransferSuccess &&
                  // !showWhatsNew &&
                  !openPin &&
                  !openSellPending &&
                  !openSellFrom &&
                  !openSellFromExAddy &&
                  !openSellFromDeex &&
                  !openSellTransfer &&
                  !openDepositAddy &&
                  !openDepositNetwork &&
                  !openSellDPreview &&
                  !openSellDPending &&
                  !selectedTransaction &&
                  !showClaimModal &&
                  !openStatement &&
                  !openStatementSuccess &&
                  !openWrapped &&
                  !openOpenWrappedModal && (
                    <div className="mt-8 w-full">
                      {/* The whole frame is the click target for whichever slide is
                          showing. Only pressable when that slide's notification carries a
                          usable CTA — otherwise it is a plain image with no pointer
                          affordance, so a malformed admin link never looks interactive. */}
                      <div
                        onClick={() => {
                          const active = slides[currentImageIndex];
                          if (active && hasNotificationLink(active.link)) {
                            openNotificationLink(active.link, navigate);
                          }
                        }}
                        className={`relative w-full overflow-hidden rounded-xl bg-[#E7EBEE] dark:bg-[#252B31] aspect-[16/10] sm:aspect-[2.1/1] lg:aspect-[2.4/1] ${
                          hasNotificationLink(slides[currentImageIndex]?.link)
                            ? "cursor-pointer"
                            : ""
                        }`}
                      >
                        {slides.map((slide, index: number) => (
                          <img
                            key={slide.id ?? slide.url}
                            src={slide.url}
                            alt={`Promotional slide ${index + 1}`}
                            loading={index === 0 ? "eager" : "lazy"}
                            decoding="async"
                            className={`absolute inset-0 h-full w-full rounded-xl object-cover object-center transition-opacity duration-1000 ${
                              index === currentImageIndex
                                ? "opacity-100 z-10"
                                : "opacity-0 z-0"
                            }`}
                          />
                        ))}
                      </div>
                      {slides.length > 1 && (
                        <div className="mt-3 flex justify-center gap-2">
                          {slides.map((_, index: number) => (
                            <button
                              key={index}
                              type="button"
                              aria-label={`Go to slide ${index + 1}`}
                              aria-current={
                                index === currentImageIndex ? "true" : undefined
                              }
                              onClick={() => setCurrentImageIndex(index)}
                              className={`h-1.5 rounded-full transition-all ${
                                index === currentImageIndex
                                  ? "w-6 bg-secondary_button"
                                  : "w-1.5 bg-gray-300 dark:bg-gray-600"
                              }`}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                {/* Desktop only — the narrow-width instance lives in the left column
                    above the transaction list. Renders only when the admin gave the
                    survey the DASHBOARD_CTA placement; the component asks per placement
                    and shows nothing otherwise, so there is no eligibility check here. */}
                <SurveyBanner className="mt-8 hidden lgss:block" />
                <div
                  onClick={() => setOpenRefer(true)}
                  className="flex justify-start bg-white dark:bg-[#1C2227] w-full px-6 py-4 mt-6 rounded-xl items-center gap-4"
                >
                  <div className="flex justify-center items-center  text-[24px] text-secondary_button  rounded-full">
                    <FaUsers />
                  </div>
                  <div>
                    <h4 className="text-secondary_button font-bold text-[14px] ">
                      Refer & Earn
                    </h4>
                    <h4 className="text-gray-500 dark:text-gray-300 mt-1 font-medium text-[12px] ">
                      Invite friends to download the DeeX application and get
                      10% off their first transaction.
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {openDeposit && (
        <SelectCoin
          setOpenDeposit={setOpenDeposit}
          setDepositNetworks={setDepositNetworks}
          setOpenDepositNetwork={setOpenDepositNetwork}
          setDepositCoinName={setDepositCoinName}
        />
      )}
      {openDepositNetwork && (
        <SelectDNetwork
          setOpenDeposit={setOpenDeposit}
          depositCoinName={depositCoinName}
          depositNetworks={depositNetworks}
          setOpenDepositNetwork={setOpenDepositNetwork}
          setOpenDepositAddy={setOpenDepositAddy}
          setDepositNetworkName={setDepositNetworkName}
        />
      )}
      {openDepositAddy && (
        <DepositAddy
          depositCoinName={depositCoinName}
          depositNetworks={depositNetworks}
          setOpenDepositNetwork={setOpenDepositNetwork}
          setOpenDepositAddy={setOpenDepositAddy}
          setDepositNetworkName={setDepositNetworkName}
          depositNetworkName={depositNetworkName}
        />
      )}
      {openSellFrom && (
        <SelectType
          setOpenSellFrom={setOpenSellFrom}
          setOpenSellFromExAddy={setOpenSellFromExAddy}
          setOpenSellFromDeex={setOpenSellFromDeex}
        />
      )}
      {openSellFromDeex && (
        <SellFromDeex
          setOpenSellFromDeex={setOpenSellFromDeex}
          setOpenSellFrom={setOpenSellFrom}
          setOpenSellPending={setOpenSellPending}
          setOpenPreview={setOpenSellDPreview}
          coinAmount={sellDCoinAmount}
          usdAmount={sellDUsdAmount}
          setCoinAmount={setSellDCoinAmount}
          setUsdAmount={setSellDUsdAmount}
          selectedCoinObj={selectedSellDCoinObj}
          setSelectedCoinObj={setSelectedSellDCoinObj}
        />
      )}

      {openSellDPreview && (
        <SellPreview
          setOpenSellFromDeex={setOpenSellFromDeex}
          setOpenPreview={setOpenSellDPreview}
          setOpenSellPending={setOpenSellPending}
          amount={sellDCoinAmount}
          usdAmount={sellDUsdAmount}
          coin={selectedSellDCoinObj}
        />
      )}
      {openSellDPending && (
        <DeexPending
          setOpenSellDPending={setOpenSellDPending}
          setOpenSellFromDeex={setOpenSellFromDeex}
        />
      )}
      {openSellFromExAddy && (
        <SellFromExAddy
          setOpenSellFromExAddy={setOpenSellFromExAddy}
          setOpenSellFrom={setOpenSellFrom}
          setOpenSellTransfer={setOpenSellTransfer}
          selectedCoinObj={selectedCoinObj}
          setSelectedCoinObj={setSelectedCoinObj}
          selectedNetwork={selectedNetwork}
          setSelectedNetwork={setSelectedNetwork}
        />
      )}
      {openSellTransfer && (
        <TransferFund
          setOpenSellPending={setOpenSellPending}
          setOpenSellTransfer={setOpenSellTransfer}
          setOpenSellFromExAddy={setOpenSellFromExAddy}
          selectedNetwork={selectedNetwork}
          selectedCoinObj={selectedCoinObj}
          setSelectedNetwork={setSelectedNetwork}
        />
      )}
      {openSellPending && (
        <Pending
          setOpenSellPending={setOpenSellPending}
          setOpenSellFrom={setOpenSellFrom}
        />
      )}
      {openSelectCard && (
        <SelectCard
          setOpenSelectCard={setOpenSelectCard}
          setOpenSelectCardValue={setOpenSelectCardValue}
          setCardId={setCardId}
          cardId={cardId}
          cardName={cardName}
          setCardName={setCardName}
          cardImg={cardImg}
          setCardImg={setCardImg}
          setCard={setCard}
          cardType={cardType}
          setCardType={setCardType}
          receiptName={receiptName}
          setReceiptName={setReceiptName}
        />
      )}
      {openSelectCardValue && (
        <SelectCardValue
          setOpenSelectCard={setOpenSelectCard}
          setOpenSelectCardValue={setOpenSelectCardValue}
          setOpenGiftcardPreview={setOpenGiftcardPreview}
          cardName={cardName}
          cardImg={cardImg}
          card={card}
          setDenominationData={setDenominationData}
          denominationData={denominationData}
        />
      )}
      {openGiftcardPreview && (
        <GiftcardPreview
          setOpenGicardUpload={setOpenGicardUpload}
          setOpenSelectCardValue={setOpenSelectCardValue}
          setOpenGiftcardPreview={setOpenGiftcardPreview}
          cardName={cardName}
          denominationData={denominationData}
        />
      )}
      {openGicardUpload && (
        <UploadGiftcard
          setOpenGicardUpload={setOpenGicardUpload}
          setOpenGiftcardPreview={setOpenGiftcardPreview}
          setOpenGicardDone={setOpenGicardDone}
          cardType={cardType}
          cardName={cardName}
          cardId={cardId}
          receiptName={receiptName}
          denominationData={denominationData}
        />
      )}
      {openGicardDone && (
        <GifcardSent
          setOpenGicardDone={setOpenGicardDone}
          setDenominationData={setDenominationData}
        />
      )}


      {openAirtime && (
        <BuyAirtime
          setOpenAirtime={setOpenAirtime}
          setOpenAirtimePreview={setOpenAirtimePreview}
          amount={amount}
          setAmount={setAmount}
          phone={phone}
          setPhone={setPhone}
          network={network}
          setNetwork={setNetwork}
          networkName={networkName}
          setNetworkName={setNetworkName}
          paymentSource={airtimePaymentSource}
          setPaymentSource={setAirtimePaymentSource}
        />
      )}
      {openAirtimePreview && (
        <AirtimePreview
          setOpenAirtimePreview={setOpenAirtimePreview}
          setOpenAirtime={setOpenAirtime}
          setOpenAirtimeSuccess={setOpenAirtimeSuccess}
          amount={amount}
          phone={phone}
          network={network}
          networkName={networkName}
          paymentSource={airtimePaymentSource}
        />
      )}
      {openAirtimeSuccess && (
        <BuySuccess
          amount={amount}
          phone={phone}
          network={networkName || network}
          setOpenAirtimeSuccess={setOpenAirtimeSuccess}
          setOpenAirtime={setOpenAirtime}
        />
      )}
      {/* BETTING */}
      {openBetting && (
        <Betting
          setOpenBetting={setOpenBetting}
          setBetId={setBetId}
          setCustomerId={setCustomerId}
          setBetAmount={setBetAmount}
          betAmount={betAmount}
          customerId={customerId}
          betId={betId}
          providerName={providerName}
          setProviderName={setProviderName}
          setCustomerName={setCustomerName}
          customerName={customerName}
          setOpenBettingPreview={setOpenBettingPreview}
          paymentSource={bettingPaymentSource}
          setPaymentSource={setBettingPaymentSource}
        />
      )}
      {openBettingPreview && (
        <BettingPreview
          setOpenBetting={setOpenBetting}
          setOpenBettingPreview={setOpenBettingPreview}
          betAmount={betAmount}
          customerId={customerId}
          betId={betId}
          setBetId={setBetId}
          providerName={providerName}
          customerName={customerName}
          setCustomerId={setCustomerId}
          setBetAmount={setBetAmount}
          setProviderName={setProviderName}
          setCustomerName={setCustomerName}
          paymentSource={bettingPaymentSource}
          setOpenBettingSuccess={setOpenBettingSuccess}
        />
      )}
      {openBettingSuccess && (
        <BettingSuccess
          betAmount={betAmount}
          providerName={providerName}
          customerName={customerName}
          setOpenBetting={setOpenBetting}
          setOpenBettingSuccess={setOpenBettingSuccess}
        />
      )}
      {/* Data */}
      {openData && (
        <BuyData
          setOpenData={setOpenData}
          amount={dataAmount}
          phone={dataPhone}
          network={dataNetwork}
          networkName={dataNetworkName}
          setAmount={setDataAmount}
          setPhone={setDataPhone}
          setNetwork={setDataNetwork}
          setNetworkName={setDataNetworkName}
          planName={planName}
          setPlanName={setPlanName}
          productSlug={dataProductSlug}
          setProductSlug={setDataProductSlug}
          paymentSource={dataPaymentSource}
          setPaymentSource={setDataPaymentSource}
          setOpenDataPreview={setOpenDataPreview}
        />
      )}
      {openDataPreview && (
        <DataPreview
          setOpenData={setOpenData}
          amount={dataAmount}
          phone={dataPhone}
          network={dataNetwork}
          networkName={dataNetworkName}
          planName={planName}
          productSlug={dataProductSlug}
          paymentSource={dataPaymentSource}
          setOpenDataPreview={setOpenDataPreview}
          setOpenDataSuccess={setOpenDataSuccess}
        />
      )}
      {openDataSuccess && (
        <DataSuccess
          amount={dataAmount}
          phone={dataPhone}
          planName={planName}
          setOpenData={setOpenData}
          setOpenDataSuccess={setOpenDataSuccess}
        />
      )}
      {/* Electricity */}
      {openElectric && (
        <BuyElectricity
          setOpenElectric={setOpenElectric}
          setOpenElectricPreview={setOpenElectricPreview}
          meterNo={meterNo}
          setMeterNo={setMeterNo}
          providerName={electricProviderName}
          setProviderName={setElectricProviderName}
          productSlug={electricProductSlug}
          setProductSlug={setElectricProductSlug}
          electricPhone={electricPhone}
          setElectricPhone={setElectricPhone}
          electricAmount={electricAmount}
          setElectricAmount={setElectricAmount}
          paymentSource={electricPaymentSource}
          setPaymentSource={setElectricPaymentSource}
          setElectricCustomerName={setElectricCustomerName}
        />
      )}
      {openElectricPreview && (
        <ElectricPreview
          setOpenElectric={setOpenElectric}
          setOpenElectricPreview={setOpenElectricPreview}
          meterNo={meterNo}
          providerName={electricProviderName}
          productSlug={electricProductSlug}
          electricPhone={electricPhone}
          electricAmount={electricAmount}
          paymentSource={electricPaymentSource}
          electricCustomerName={electricCustomerName}
          setOpenElectricSuccess={setOpenElectricSuccess}
          setElectricReceipt={setElectricReceipt}
        />
      )}
      {openElectricSuccess && (
        <ElectricSuccess
          setOpenElectric={setOpenElectric}
          meterNo={meterNo}
          serviceProvider={electricProviderName}
          electricPhone={electricPhone}
          electricAmount={electricAmount}
          setOpenElectricSuccess={setOpenElectricSuccess}
          electricReceipt={electricReceipt}
        />
      )}
      {openTransfer && (
        <Tranfer
          setOpenTransfer={setOpenTransfer}
          setOpenTransferPreview={setOpenTransferPreview}
          setOpenTransferSuccess={setOpenTransferSuccess}
          transferAmount={transferAmount}
          setTransferAmount={setTransferAmount}
          transferBankName={transferBankName}
          setTransferBankName={setTransferBankName}
          transferBankNumber={transferBankNumber}
          setTransferBankNumber={setTransferBankNumber}
          transferBankCode={transferBankCode}
          setTransferBankCode={setTransferBankCode}
          transferUserBankName={transferUserBankName}
          setTransferUserBankName={setTransferUserBankName}
          transferSelectedCoinObj={transferSelectedCoinObj}
          setTransferSelectedCoinObj={setTransferSelectedCoinObj}
          transferFee={transferFee}
          setTransferFee={setTransferFee}
        />
      )}
      {openTransferPreview && (
        <TransferPreview
          setOpenTransfer={setOpenTransfer}
          setOpenTransferPreview={setOpenTransferPreview}
          amount={transferAmount}
          selectedCoinObj={transferSelectedCoinObj}
          bankNumber={transferBankNumber}
          bankName={transferBankName}
          userBankName={transferUserBankName}
          fee={50}
          bankCode={transferBankCode}
          setOpenTransferSuccess={setOpenTransferSuccess}
        />
      )}
      {openTransferSuccess && (
        <TransferSuccess
          setOpenTransferSuccess={setOpenTransferSuccess}
          setOpenTransfer={setOpenTransfer}
          amount={transferAmount}
          selectedCoinObj={transferSelectedCoinObj}
          bankNumber={transferBankNumber}
          bankName={transferBankName}
          userBankName={transferUserBankName}
          fee={50}
          bankCode={transferBankCode}
          setTransferAmount={setTransferAmount}
          setTransferBankName={setTransferBankName}
          setTransferBankNumber={setTransferBankNumber}
          setTransferBankCode={setTransferBankCode}
          setTransferUserBankName={setTransferUserBankName}
        />
      )}
      {openStatement && (
        <GenerateStatament
          setOpenStatement={setOpenStatement}
          setOpenSuccess={setOpenStatementSuccess}
        />
      )}

      {openOpenWrappedModal && (
        <OpenWrappedModal
          setOpenOpenWrappedModal={setOpenOpenWrappedModal}
          setOpenWrapped={setOpenWrapped}
        />
      )}
      {showClaimModal && (
        <ClaimModal
          setShowClaimModal={setShowClaimModal}
          onNavigateKyc={() => {
            setShowClaimModal(false);
            navigate("/kyc-verification");
          }}
          onOpenSellFlow={() => {
            setShowClaimModal(false);
            setOpenSellFrom(true);
          }}
          onOpenRewardsStep={() => {
            setShowClaimModal(false);
            setOpenRewards(true);
          }}
        />
      )}
      {openPin && <ChangeTxnPin setOpenPin={setOpenPin} />}
      {openRefer && <Referral setOpenRefer={setOpenRefer} />}
      {openInviteCode && (
        <InviteCodeModal setOpenInviteCode={setOpenInviteCode} />
      )}
      {/* {showUpdatdeModal ? (
          <UpdateModal setShowUpdateModal={setShowUpdateModal} />
        ) : null} */}
      {openGiftcardRate && (
        <GiftcardRate setOpenGiftcardRate={setOpenGiftcardRate} />
      )}
      {redeemModal && <RedeemModal setRedeemModal={setRedeemModal} />}

      {isPopUpModalOpen && (
        <div className="fixed inset-0  flex font-sora justify-center items-center pt-16 pb-16 overflow-auto bg-black  bg-opacity-80">
          <div
            className={` w-11/12 mds:w-9/12     rounded-xl mx-auto  h-[600px] flex justify-center items-center flex-col   lgss:w-[38%] `}
          >
            <div className="w-full rounded-3xl flex justify-center items-center">
              {popupImage ? (
                <img
                  src={popupImage ?? ""}
                  className="w-full h-full object-contain rounded-3xl"
                  alt=""
                />
              ) : null}
            </div>
            {/* CTA only when the admin attached a usable link. Solid blue with white text,
                full width, sitting above the circular close button — bg-secondary_button is
                the token the rest of the app's primary actions use (`primary` here is
                #161616, i.e. black, not the brand blue). */}
            {hasNotificationLink(popupLink) && (
              <button
                onClick={handlePopUpCta}
                className="w-full mt-6 rounded-lg bg-secondary_button py-3.5 text-[15px] font-semibold text-white"
              >
                Learn more
              </button>
            )}
            <div className="w-full flex justify-center mt-6  items-center">
              <button
                onClick={handleCloseModal}
                className="w-[40px] h-[40px] rounded-full bg-gray-800 dark:bg-gray-200    flex justify-center items-center"
              >
                <IoCloseCircle className="text-white dark:text-black text-[22px]" />
              </button>
            </div>
          </div>
        </div>
      )}

      {openPhoneCheck && (
        <PhoneCheck
          setOpenPhoneCheck={setOpenPhoneCheck}
          setOpenAddPhone={setOpenAddPhone}
          setOpenAddOtp={setOpenAddOtp}
          openAddOtp={openAddOtp}
          phoneNumber={phoneNumber}
          onDismissPhoneVerifyPrompt={onDismissPhoneVerifyPrompt}
        />
      )}
      {openAddPhone && (
        <AddPhone
          setOpenAddPhone={(value) => {
            if (value === false) {
              sessionStorage.removeItem(SHOW_ADD_PHONE_AFTER_LOGIN_KEY);
            }
            setOpenAddPhone(value);
          }}
          setOpenAddOtp={setOpenAddOtp}
          setOpenPhoneCheck={setOpenPhoneCheck}
        />
      )}
      {openAddOtp && (
        <AddOtp
          setOpenAddOtp={setOpenAddOtp}
          setOpenSuccess={setOpenPhoneSuccess}
        />
      )}
      {openPhoneSuccess && (
        <Success
          setOpenSuccess={setOpenPhoneSuccess}
          setOpenPhoneCheck={setOpenPhoneCheck}
        />
      )}

      {/* Two-step, matching the Activity page and the app: the row opens the
          detail view, and the receipt is reached from there. */}
      {selectedTransaction && !showReceipt && (
        <TransactionDetailsModal
          transaction={selectedTransaction}
          onClose={() => {
            setShowReceipt(false);
            setSelectedTransaction(null);
          }}
          onViewReceipt={() => setShowReceipt(true)}
        />
      )}
      {selectedTransaction && showReceipt && (
        <ActivityDetailsModal
          transaction={selectedTransaction}
          onClose={() => setShowReceipt(false)}
        />
      )}

      {/* WhatsNew modal hidden per request */}
    </div>
  );
};

export default Crypto;
